const Ajax = require('common/infra/ajax');

class API {
    constructor() {
        // TODO: 本来 API は Cursor を保持するべきではない
        this._cursors = {};
        this._mores = {};
    }

    _basePath(groupKey) {
        let path = `/api/my/project-statuses`;

        if(groupKey) {
            return `${path}?groupKey=${groupKey.toUrlsafeString()}&`;
        } else {
            return `${path}?`;
        }
    }

    /**
     * ProjectStatus 一覧を取得する
     *
     * @param groupKey
     * @param limit
     * @returns {*}
     */
    fetchNext(groupKey, limit) {
        const basePath = this._basePath(groupKey);
        let path = basePath;

        if(_.has(this._cursors, path)) {
            path = `${path}cursor=${this._cursors[path]}&`;
        }

        return Ajax.GET(`${path}limit=${limit}`)
            .then(data => {
                this._cursors[basePath] = data.cursor;
                this._mores[basePath] = data.more;

                return data.projectStatuses;
            });
    }

    hasNext(groupKey) {
        const path = this._basePath(groupKey);
        return _.has(this._mores, path) && this._mores[path];
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./balus/infra/api/my/project-status.js